export default __webpack_public_path__ + "static/media/WordWork_10.881ab237.png";